import { FC } from 'react';
import { SvgProps } from './domain';

const LightBulb: FC<SvgProps> = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox='0 0 30 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_1203_2745)'>
        <path
          d='M12.4663 22.5H13.75V16.25H16.25V22.5H17.5336C17.6986 20.998 18.4651 19.7581 19.7095 18.4032C19.8496 18.2507 20.7485 17.3205 20.8551 17.1876C21.9147 15.8664 22.5 14.2312 22.5 12.5C22.5 8.35786 19.1421 5 15 5C10.8579 5 7.5 8.35786 7.5 12.5C7.5 14.2304 8.08468 15.8646 9.14328 17.1855C9.25005 17.3187 10.151 18.2515 10.2894 18.4023C11.5346 19.758 12.3013 20.998 12.4663 22.5ZM12.5 25V26.25H17.5V25H12.5ZM7.19244 18.749C5.82056 17.0371 5 14.8644 5 12.5C5 6.97715 9.47715 2.5 15 2.5C20.5229 2.5 25 6.97715 25 12.5C25 14.8656 24.1785 17.0394 22.8054 18.7518C22.03 19.7185 20 21.25 20 23.125V26.25C20 27.6308 18.8807 28.75 17.5 28.75H12.5C11.1193 28.75 10 27.6308 10 26.25V23.125C10 21.25 7.96823 19.717 7.19244 18.749Z'
          fill='url(#paint0_linear_1203_2745)'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_1203_2745'
          x1='15'
          y1='2.5'
          x2='15'
          y2='28.75'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#00D2A4' />
          <stop offset='1' stopColor='#006FFF' />
        </linearGradient>
        <clipPath id='clip0_1203_2745'>
          <rect width='30' height='30' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LightBulb;
